import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import LoadEnrollmentInProgressTable from "../LoadEnrollment/LoadEnrollmentInProgressTable";
import { DeleteIconStyled } from "../LoadEnrollment/LoadEnrollment.styles";

const LoadISOEnrollment = (props) => {
  const { setSubmenuMerchantTerminal, setSelectedOption, setNameSection } =
    props;

  const columns = [
    { id: "isoAddress", label: "ISO Address" },
    { id: "isoName", label: "ISO Name" },
    { id: "isoEmail", label: "ISO Email" },
    {
      id: "enrollment_completed",
      label: "Status",
      format: (value) => (value ? "Completed" : "Pending"),
    },
    {
      id: "action",
      label: "Actions",
      actions: [
        {
          icon: <EditIcon />,
          label: "Set to Complete",
          onClick: () => {},
        },
        {
          icon: <DeleteIconStyled />,
          label: "Delete",
          onClick: () => {},
        },
      ],
    },
  ];

  return (
    <LoadEnrollmentInProgressTable
      enrollmentType="ISO"
      columns={columns}
      deleteLabelField="isoName"
      searchPlaceholder="ISO name, email, or address"
      onContinue={() => {
        setSubmenuMerchantTerminal("iso_enrollment");
        setSelectedOption("iso_enrollment");
        setNameSection("Administrative - ISO Enrollment");
      }}
    />
  );
};

export default LoadISOEnrollment;
